export default "__VITE_ASSET__DozkjoiN__"